import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import QuickSearchSelect from '../../components/forms/QuickSearchSelect';
import _ from 'lodash';

class AccountsPayablePlanCreditDebitSelect extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    handleChange(value) {
        const { items } = this.props;
        const item = _.head(items.filter(it => it._id === value));
        this.props.onChangeItem(item || null);
    }

    render() {
        const { items = [] } = this.props;
        const { value, isValid, isLoading } = this.props;
        return (
            <QuickSearchSelect
                items={items.map(item => ({ value: item._id, label: item.code }))}
                value={value}
                isValid={isValid}
                onChange={id => this.handleChange(id)}
                isLoading={isLoading}
            />
        );
    }
}

AccountsPayablePlanCreditDebitSelect.propTypes = {
    items: PropTypes.objectOf(PropTypes.any),
    value: PropTypes.objectOf(PropTypes.any),
    isValid: PropTypes.bool,
    isLoading: PropTypes.bool,
    onChangeItem: PropTypes.func,
};

AccountsPayablePlanCreditDebitSelect.defaultProps = {
    value: null,
    isValid: null,
    isLoading: false,
    onChangeItem: f => f,
};

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(AccountsPayablePlanCreditDebitSelect);
